// extracted by mini-css-extract-plugin
export default {"detailBtn":"style_detailBtn__6Ulfg"};